var React = require('react');

function BackendDropdownMenuSes (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Messaging"),React.createElement("g",{"key":1},[React.createElement("polygon",{"points":"31.4 21.96 14.7 48.55 31.4 75.14 44.74 71.72 45.4 25.55 31.4 21.96","fill":"#876929","key":0}),React.createElement("polygon",{"points":"50.05 70.36 31.4 75.14 31.4 21.96 50.05 26.74 50.05 70.36","fill":"#d9a741","key":1}),React.createElement("polygon",{"points":"47.83 31.08 50.05 91.16 85.3 73.53 85.29 28.65 76.3 30.14 47.83 31.08","fill":"#876929","key":2}),React.createElement("polygon",{"points":"61.28 42.95 72.28 42.3 83.15 22.58 55.66 8.84 45.4 13.33 61.28 42.95","fill":"#876929","key":3}),React.createElement("polygon",{"points":"55.66 8.84 83.15 22.58 72.28 42.3 55.66 8.84","fill":"#d9a741","key":4}),React.createElement("polygon",{"points":"50.05 14.54 72.28 54.88 76.1 78.13 50.05 91.16 39.5 85.88 39.5 18.76 50.04 14.54 50.05 14.54","fill":"#876929","key":5}),React.createElement("polygon",{"points":"85.29 28.65 85.3 73.53 50.05 91.16 50.05 14.54 72.28 54.88 85.29 28.65","fill":"#d9a741","key":6})])]);
}

BackendDropdownMenuSes.displayName = "BackendDropdownMenuSes";

BackendDropdownMenuSes.defaultProps = {"id":"Layer_1","data-name":"Layer 1","width":"100","height":"100","viewBox":"0 0 100 100"};

module.exports = BackendDropdownMenuSes;

BackendDropdownMenuSes.default = BackendDropdownMenuSes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/svg/menu-icons/backend-dropdown-menu-ses.svg
// module id = 497
// module chunks = 0